import type { Email } from '#types';
import { typeFn } from '#utils/typeFn';

const fn = typeFn<Email>()();

export default fn;
